import { getProjectWorkspacesSelected, updateProjectWorkspacesSelected } from 'Services/user';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { trackError } from 'Utils/errorMonitoring';

export default function useWorkspaceSelected() {
    const { data: workspace = {}, isLoading } = useQuery({
        queryKey: ['project-workspace-selected'],
        queryFn: getProjectWorkspacesSelected,
        onError: (error) => trackError(error),
    });

    const queryClient = useQueryClient();

    const { mutate: updateWorkspace } = useMutation({
        mutationFn: (payload) => updateProjectWorkspacesSelected(workspace.id, payload),
        onMutate: (payload) => {
            const previousWorkspace = queryClient.getQueryData(['project-workspace-selected']);

            queryClient.setQueryData(['project-workspace-selected'], (old) => {
                if (!old) return old;

                return {
                    ...old,
                    ...payload,
                };
            });

            return { previousWorkspace };
        },
        onError: (err, _module, context) => {
            trackError(err);
            queryClient.setQueryData(['project-workspace-selected'], context.previousWorkspace);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['project-workspace-selected'] });
            queryClient.invalidateQueries({ queryKey: ['project-selected', 'workspaces'] });
        },
    });

    return { workspace, isLoading, updateWorkspace };
}
